import { useTable, useSortBy, Column } from "react-table";
import { KTIcon } from "../../../../_metronic/helpers";
import "../../../../_metronic/assets/sass/components/CustomTable.scss";
import { getProvinceReported, getProvinceReportedExcel } from "../../../api/attendees/attendeesApi";
import { useQuery } from "react-query";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useFormik } from "formik";
import React from "react";
import BackBtn from "../lib/BackBtn";
import { FileDownloader } from "../lib";

interface ProvinceData {
  total_male: number;
  total_female: number;
  total: number;
  province: string;
}

interface TableData extends ProvinceData {
  id: string;
}

type APIResponse = Record<string, ProvinceData>;

const Loader = () => {
  return (
    <div className="flex items-center justify-center h-[400px]">
      <div className="w-12 h-12 rounded-full border-4 border-primary border-t-transparent animate-spin"></div>
    </div>
  );
};

const ProvinceReport = () => {
  const location = useLocation();
  const matchId = location.state;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const pageFromQuery = searchParams.get("page");

  const page = pageFromQuery ? parseInt(pageFromQuery) : 1;

  const {
    data: reportData,
    isLoading,
    isError,
  } = useQuery<APIResponse>(
    ["province-report", matchId],
    () => getProvinceReported({ matchId }),
    {
      enabled: !!matchId,
    }
  );

  const columns = React.useMemo<Column<TableData>[]>(
    () => [
      {
        Header: <HeaderTextIcon text={"ردیف"} />,
        accessor: "id",
        Cell: ({ row: { index } }) => <span className="rowNum">{index + 1}</span>,
      },
      {
        Header: <HeaderTextIcon text={"نام استان"} />,
        accessor: "province",
      },
      {
        Header: <HeaderTextIcon text={"تعداد مردان"} />,
        accessor: "total_male",
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: <HeaderTextIcon text={"تعداد زنان"} />,
        accessor: "total_female",
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: <HeaderTextIcon text={"مجموع"} />,
        accessor: "total",
        Cell: ({ value }) => <span>{value}</span>,
      },
    ],
    []
  );

  const tableData = React.useMemo(() => {
    if (!reportData) return [];
    return Object.entries(reportData as APIResponse).map(([id, province]) => ({
      id,
      ...province,
    }));
  }, [reportData]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable<TableData>(
    {
      columns,
      data: tableData,
    },
    useSortBy
  );

  const { data: exportToExcel, refetch: exportToExcelRefetch } = useQuery(
    ["export-to-excel"],
    () => getProvinceReportedExcel({ matchId }),
    {
      enabled: false,
    }
  );

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return <div>خطا در دریافت اطلاعات</div>;
  }

  if (!matchId) {
    return <div>لطفا یک مسابقه را انتخاب کنید</div>;
  }

  const goBack = () => navigate(-1);

  return (
    <div className="bg-white pt-5">
       <div
        className={
          "card-title mt-5 mb-1 px-10 d-flex align-items-center justify-content-between pb-8"
        }
      >
        <h2>جزئیات درخواست  استان</h2>
        <BackBtn onClick={goBack} />
      </div>
      <div className=" p-10 d-flex">
            <div className="d-flex gap-5  align-items-center">
              <div>خروجی اکسل</div>

              <FileDownloader
                downloadFunc={() => {
                  exportToExcelRefetch();
                }}
              />
            </div>
          </div>
      <div style={{ overflow: "auto" , "backgroundColor": "white" , borderBottom: "1px  solid #F1F1F4",
          borderTop: " 1px solid #F1F1F4", }} >
        <table
          {...getTableProps()}
          style={{
            borderCollapse: "collapse",
            columnGap: "20px",
            direction: "rtl",
            minWidth: "100%",
            width: "100%",
            backgroundColor: "white",
          }}
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} style={{backgroundColor: "white"}}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      
    </div>
    
  );
};

const HeaderTextIcon = ({ text }: { text: string }) => {
  return (
    <div
      className="d-flex align-items-center justify-content-center gap-2"
      style={{ whiteSpace: "nowrap", margin: "0 5px" }}
    >
      <span>{text}</span>
      <KTIcon iconName="filter" className="fs-5" />
    </div>
  );
};

export default ProvinceReport;